import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "mau_modal_menor_servicio_programado_header"
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" })
], -1)
const _hoisted_6 = {
  class: "scroll-y",
  id: "mau_modal_menor_servicio_programado_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#mau_modal_menor_servicio_programado_header",
  "data-kt-scroll-wrappers": "#mau_modal_menor_servicio_programado_scroll",
  "data-kt-scroll-offset": "200px"
}
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_10 = { class: "col fv-row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_13 = { style: {"color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_14 = { class: "mb-6" }
const _hoisted_15 = {
  class: "col-lg-12 fw-normal fs-6 mb-4",
  style: {"white-space":"break-spaces"}
}
const _hoisted_16 = { class: "col fv-row" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col fv-row fv-plugins-icon-container" }
const _hoisted_19 = { class: "modal-footer flex-center" }
const _hoisted_20 = {
  type: "reset",
  id: "mau_modal_add_oganizacion_cancel",
  class: "btn btn-light me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_21 = ["data-kt-indicator", "disabled"]
const _hoisted_22 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_23 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { useModal } from "@/composable/useModal";
import { hideModal } from "@/core/helpers/dom";
import { Menor } from "@/store/models";
import {
  AuthModule,
  FamiliasListadoModule,
  ServiciosProgramadosModule,
} from "@/store/modules";
import Swal from "sweetalert2";
import { useField, useForm } from "vee-validate";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormValues {
  menorId: string;
  familiaId: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const module = getModule(FamiliasListadoModule, store);
const moduleServiciosProgramados = getModule(ServiciosProgramadosModule, store);

const authModule = getModule(AuthModule, store);

const comarcaId = authModule.user.comarcaId;

const { t } = useI18n();
const { modalRef, isShown } = useModal();

onMounted(() => {
  resetForm();
});
watch(isShown, async (value) => {
  if (!value || !module.familiasListado) return;

  resetForm();

  try {
    module.fetchFamilias(comarcaId);
  } catch (err) {
    Swal.fire({
      text: t("formularios.familiasListado.cargar.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  }
});

const familias = computed(() => {
  const familiasListado = module.familiasListado || [];
  return familiasListado.sort(function (a, b) {
    return a.nombre < b.nombre ? -1 : 0;
  });
});

const validationSchema = Yup.object({
  menorId: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.menor.label")),
  familiaId: Yup.string()
    .required()
    .label(t("formularios.familiaDetalle.familia.label")),
});
const { handleSubmit, resetForm, meta, values } = useForm<FormValues>({
  validationSchema,
});
const { value: menorId } = useField("menorId");
const { value: familiaId } = useField("familiaId");

const menores = ref<Menor[]>([]);
watch(
  () => values.familiaId,
  async () => {
    menores.value = [];
    menorId.value = "";

    if (values.familiaId) {
      await module.fetchById({
        comarcaId: comarcaId,
        id: values.familiaId,
      });
      menores.value = module.familia?.menores ?? [];
    }
  }
);

const token = route.params.id;

const loading = ref(false);
const submit = handleSubmit(async () => {
  if (!module.familia?.comarcaId || !module.familia?.id) return;

  try {
    loading.value = true;
    await module.addServioProgramadoMenor({
      comarcaId: !authModule.user.comarcaId
        ? undefined
        : module.familia?.comarcaId,
      familiaId: module.familia?.id,
      menorId: menorId.value as string,
      servicioProgramadoId: token as string,
    });

    await moduleServiciosProgramados.fetchById({
      comarcaId: comarcaId,
      id: token as string,
    });

    await Swal.fire({
      text: t("dialogs.añadirMenorServicio.success"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      heightAuto: false,
      customClass: {
        confirmButton: "btn fw-semobold btn-light-primary",
      },
    });
    hideModal(modalRef.value);
  } catch (error) {
    Swal.fire({
      text: t("dialogs.añadirMenorServicio.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "mau_modal_incluir_menor_servicio",
    ref_key: "modalRef",
    ref: modalRef,
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    "aria-label": "Nueva solicitud de servicio programado",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("dialogs.añadirMenorServicio.titulo")), 1),
          _hoisted_5
        ]),
        _createElementVNode("form", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("dialogs.añadirMenorServicio.familia.label")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(familiaId),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(familiaId) ? (familiaId).value = $event : null)),
                        filterable: "",
                        class: "w-100",
                        placeholder: 
                          _ctx.$t('dialogs.añadirMenorServicio.familia.placeholder')
                        ,
                        "no-data-text": 
                          _ctx.$t('dialogs.añadirMenorServicio.familia.noDataText')
                        ,
                        "popper-class": "w-auto"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(familias), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: 
                            item.nombre +
                            ' ' +
                            item.apellidos +
                            ' - ' +
                            item.dni
                          ,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nombre) + " " + _toDisplayString(item.apellidos) + " ", 1),
                                _createElementVNode("span", _hoisted_13, _toDisplayString(item.dni), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "no-data-text"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("dialogs.añadirMenorServicio.menores.label")), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(menorId),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(menorId) ? (menorId).value = $event : null)),
                        filterable: "",
                        class: "w-100",
                        placeholder: 
                          _ctx.$t('dialogs.añadirMenorServicio.menores.placeholder')
                        ,
                        "no-data-text": 
                          _ctx.$t('dialogs.añadirMenorServicio.menores.noDataText')
                        ,
                        "popper-class": "w-auto"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menores.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.nombre + ' ' + item.apellidos,
                              value: item.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.nombre) + " " + _toDisplayString(item.apellidos), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "no-data-text"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", _hoisted_20, _toDisplayString(_ctx.$t("dialogs.cancelButton")), 1),
          _createElementVNode("button", {
            "data-kt-indicator": loading.value ? 'on' : null,
            class: "btn btn-lg btn-primary",
            type: "submit",
            disabled: !_unref(meta).valid,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(submit)()))
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t("dialogs.add")), 1))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dialogs.addLoading")) + " ", 1),
                  _hoisted_24
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_21)
        ])
      ])
    ])
  ], 512))
}
}

})